import {Component} from '@angular/core';
import {GlobalsService} from '@/_services/globals.service';
import {CdkDrag, CdkDragHandle} from '@angular/cdk/drag-drop';
import {MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {CloseButtonData} from '@/controls/close-button/close-button-data';

@Component({
  selector: 'app-impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss'],
  imports: [
    CdkDrag,
    CdkDragHandle,
    MatDialogTitle,
    MatIcon,
    MatDialogContent,
    MatDialogClose,
    MatIconButton
  ]
})
export class ImpressumComponent {
  closeData: CloseButtonData = {
    colorKey: 'legal'
  };

  constructor(public globals: GlobalsService) {
  }
}
